import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/expenses.actions';
import {
  ExpenseOperationStatus,
  ExpenseRequestStatus,
  ExpenseSubmitType,
  InitExpensesState,
  initialExpensesState,
} from '../state/expenses.state';

export const expensesFeatureStoreKey: string = 'expensesState';

export const reducers = (
  state: InitExpensesState,
  action: Action,
): InitExpensesState => {
  return initExpensesReducer(state, action);
};

export const initExpensesReducer = createReducer(
  initialExpensesState,
  on(actions.clearExpensesState, () => initialExpensesState),
  on(actions.createNewExpense, (state, { newExpense }) => ({
    ...state,
    newExpense,
    isNewExpenseSubmitProcessing: ExpenseSubmitType.PROCESSING,
  })),
  on(actions.createNewExpenseSuccess, (state) => ({
    ...state,
    isNewExpenseSubmitProcessing: ExpenseSubmitType.SUCCESS,
    allocatedExpenses: [],
  })),
  on(actions.createNewExpenseError, (state) => ({
    ...state,
    isNewExpenseSubmitProcessing: ExpenseSubmitType.ERROR,
  })),
  on(actions.updateAllocatedExpenses, (state, { allocatedExpenses }) => {
    return {
      ...state,
      allocatedExpenses,
    };
  }),
  on(actions.getExpenses, (state) => ({
    ...state,
    expensesRequestStatus: ExpenseRequestStatus.LOADING,
  })),
  on(actions.getExpensesSuccess, (state, { expenses }) => ({
    ...state,
    expenses,
    expensesRequestStatus: ExpenseRequestStatus.SUCCESS,
  })),
  on(actions.getExpensesError, (state) => ({
    ...state,
    expensesRequestStatus: ExpenseRequestStatus.ERROR,
  })),
  on(actions.selectedExpense, (state, { selectedExpense }) => ({
    ...state,
    selectedExpense,
    selectedUserExpenses: [],
    selectedUserExpensesRequestStatus: ExpenseRequestStatus.LOADING,
  })),
  on(actions.getExpenseTransactions, (state) => ({
    ...state,
    selectedUserExpensesRequestStatus: ExpenseRequestStatus.LOADING,
  })),
  on(
    actions.getExpenseTransactionsSuccess,
    (state, { selectedUserExpenses }) => ({
      ...state,
      selectedUserExpenses,
      selectedUserExpensesRequestStatus: ExpenseRequestStatus.SUCCESS,
      selectedExpense: selectedUserExpenses.length
        ? state.selectedExpense
        : null,
      selectedUserExpense: state.selectedUserExpense
        ? selectedUserExpenses.length
          ? (selectedUserExpenses.find(
              (expense) =>
                expense.expenseId === state.selectedUserExpense.expenseId,
            ) ?? state.selectedUserExpense)
          : null
        : null,
    }),
  ),
  on(actions.getExpenseTransactionsError, (state) => ({
    ...state,
    selectedUserExpensesRequestStatus: ExpenseRequestStatus.ERROR,
  })),
  on(actions.clearSelectedExpense, (state) => ({
    ...state,
    selectedExpense: null,
    selectedUserExpenses: [],
    selectedUserExpense: null,
  })),
  on(actions.deleteExpenseTransaction, (state) => ({
    ...state,
    deleteExpenseSubmitProcessing: ExpenseOperationStatus.PROCESSING,
  })),
  on(actions.deleteExpenseTransactionSuccess, (state, { expenseId }) => ({
    ...state,
    selectedUserExpenses: [
      ...state.selectedUserExpenses.filter(
        (expense) => expense.expenseId !== expenseId,
      ),
    ],
    selectedUserExpense: null,
    deleteExpenseSubmitProcessing: ExpenseOperationStatus.SUCCESS,
  })),
  on(actions.deleteExpenseTransactionError, (state) => ({
    ...state,
    deleteExpenseSubmitProcessing: ExpenseOperationStatus.ERROR,
  })),
  on(actions.viewSelectedUserExpense, (state, { selectedUserExpense }) => ({
    ...state,
    selectedUserExpense,
  })),
  on(actions.clearSelectedUserExpense, (state) => ({
    ...state,
    selectedUserExpense: null,
  })),
  on(actions.updateExpenseTransaction, (state) => ({
    ...state,
    updateExpenseSubmitProcessing: ExpenseOperationStatus.PROCESSING,
  })),
  on(actions.updateExpenseTransactionSuccess, (state) => ({
    ...state,
    updateExpenseSubmitProcessing: ExpenseOperationStatus.SUCCESS,
  })),
  on(actions.updateExpenseTransactionError, (state) => ({
    ...state,
    updateExpenseSubmitProcessing: ExpenseOperationStatus.ERROR,
  })),
);

export const expensesFeature = createFeature({
  name: expensesFeatureStoreKey,
  reducer: reducers,
});
